import React, { useState } from "react";
import { Copy, Check, Barcode } from "lucide-react";
import { cn } from "@/lib/utils";

/** Compact UPC / Walmart ID chip with functional copy (no placeholders). */
export function IdentChip({ label, value, testId }) {
  const [copied, setCopied] = useState(false);
  const present = value != null && String(value).trim() !== "";
  const text = present ? String(value) : "—";

  const copy = async (e) => {
    e.stopPropagation();
    if (!present || typeof navigator === "undefined" || !navigator.clipboard) return;
    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1200);
    } catch {
      /* clipboard may be denied — leave chip visible without claiming success */
    }
  };

  return (
    <span
      className={cn("pc-id-chip", !present && "pc-id-chip-muted")}
      data-testid={testId}
      title={present ? `${label}: ${text}` : `${label} unavailable`}
    >
      <Barcode className="w-3 h-3 shrink-0" aria-hidden="true" />
      <span className="truncate">
        <span className="text-[10px] font-semibold uppercase tracking-wide text-ink-muted mr-1">{label}</span>
        {text}
      </span>
      <button
        type="button"
        aria-label={present ? `Copy ${label}` : `${label} unavailable`}
        disabled={!present}
        onClick={copy}
        data-testid={testId ? `${testId}-copy` : undefined}
      >
        {copied ? <Check className="w-3 h-3 text-emerald-600" /> : <Copy className="w-3 h-3" />}
      </button>
    </span>
  );
}

export default IdentChip;
